import { render, staticRenderFns } from "./lazy_list_y.vue?vue&type=template&id=1857ed37&"
import script from "./lazy_list_y.vue?vue&type=script&lang=js&"
export * from "./lazy_list_y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports